/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { SocialLoginActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        socialLogins: state.socialLogins
    });
}

function mapDispatchToProps(dispatch) {
    return {
        getSocialLogins: () => {
            dispatch(SocialLoginActions.fetchSocialLogins());
        },
        deleteSocialLogin: (id) => {
            dispatch(SocialLoginActions.deleteSocialLogin(id));
        },
        createSocialLogin: (social) => {
            dispatch(SocialLoginActions.createSocialLogin(social));
        }
	};
}

export default function SocialLoginProvider(Component) {

    class SocialLoginProvider extends React.Component {
        render() {
            return (
                <Component {...this.props}/>
            );
        }
    }

    SocialLoginProvider.displayName = "SocialLoginProvider";

    return connect(mapStateToProps, mapDispatchToProps)(SocialLoginProvider);
};
